module.exports = __webpack_public_path__ + "front/img/20_m.1fecb492.jpg";